/// <reference path="../../ng-services/chat.service.ts"/>

import { ChatConversationMessage } from '../../models/chat';
import { ChatConversationService } from '../../ng-services/chat-conversation.service';

(function () {
    class ChatQuotedMessageComponent {
        public quotedMessage!: ChatConversationMessage;

        static $inject = ['ChatConversationService'];

        constructor(private chatConversationService: ChatConversationService) {}

        get image() {
            return this.quotedMessage.owner.picture_url;
        }

        get messageHref() {
            return `#chat-message-${this.quotedMessage.id}`;
        }

        gotoMessage() {
            this.quotedMessage.meeting_id &&
                this.chatConversationService.gotoMessage(this.quotedMessage.meeting_id, this.quotedMessage.id);
        }
    }

    angular.module('tradersyard').component('tyChatQuotedMessage', {
        // language=HTML
        template: `
        <div class="chat_quoted_message">
            <div class="chat_quoted_message__user">
                <img ng-src="{{$ctrl.image|thumb:80:80}}" alt="avatar">
                {{$ctrl.quotedMessage.owner.name}}
            </div>
            <div class="chat_quoted_message__message" ng-bind-html="$ctrl.quotedMessage.content|emojis|markdown"></div>
            <div ng-if="!$ctrl.isPublicChat">
                <a ng-href="{{$ctrl.messageHref}}" ng-click="$ctrl.gotoMessage()">view message</a>
            </div>
        </div>
`,
        bindings: {
            quotedMessage: '<',
            isPublicChat: '<',
        },
        controller: ChatQuotedMessageComponent,
    });
})();
